module.exports = __webpack_public_path__ + "img/website_icon.ef269ff2.png";